import React from 'react'
import {FaRegCheckCircle} from "react-icons/fa";
import {TbCertificate } from "react-icons/tb";

const Benifits = ({textColor, textShadow, bonuses}) => {

  const bonus = bonuses;
  // Parse the HTML content and extract paragraphs
  const parseOfferContent = (htmlContent) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');
    return Array.from(doc.querySelectorAll('p')).map(p => p.textContent);
  };

  const bonusItems = bonus?.offer ? parseOfferContent(bonus.offer) : [];

  return (
    <>
      <div className="p-6 border-b border-gray-100">
        <h4 className="font-bold text-gray-800 mb-4 flex items-center">
            <TbCertificate className={`${textColor} mr-2`} />
            {bonus?.headline || "You Will Get:"}
        </h4>
        <ul className="space-y-3">
          {bonusItems.map((item, index) => (
            <li key={index} className="flex items-start">
              <div className={`${textColor} p-1 rounded-full mr-3 mt-1`}>
                <FaRegCheckCircle className={`${textColor} text-sm`} />
              </div>
              <span className="text-gray-700">{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </>
  )
}

export default Benifits